import MUITabs from '@mui/material/Tabs';

type TabsProps = {
  action?: (...args: any[]) => any;
  allowScrollButtonsMobile?: boolean;
  'aria-label'?: string;
  'aria-labelledby'?: string;
  centered?: boolean;
  classes?: any;
  component?: React.ElementType<any>;
  indicatorColor?: 'primary' | 'secondary';
  onChange?: (...args: any[]) => any;
  orientation?: 'horizontal' | 'vertical';
  ScrollButtonComponent?: React.ElementType<any>;
  scrollButtons?: 'auto' | false | true;
  selectionFollowsFocus?: boolean;
  slotProps?: {
    endScrollButtonIcon?: (...args: any[]) => any;
    startScrollButtonIcon?: (...args: any[]) => any;
  };
  slots?: {
    EndScrollButtonIcon?: React.ElementType<any>;
    StartScrollButtonIcon?: React.ElementType<any>;
  };
  sx?: any;
  TabIndicatorProps?: any;
  TabScrollButtonProps?: any;
  textColor?: 'inherit' | 'primary' | 'secondary';
  value?: any;
  variant?: 'fullWidth' | 'scrollable' | 'standard';
  visibleScrollbar?: boolean;
  children: React.ReactNode;
};

const Tabs = ({ children, ...props }: Readonly<TabsProps>) => {
  return <MUITabs {...props}>{children}</MUITabs>;
};

export default Tabs;
